"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getUserGroupChallengeRequestResult = exports.getIsUserGroupChallengeLoadingSelector = exports.getUserGroupChallengeDataSelector = exports.getUserGroupChallengeSelector = exports.getUserChallengeActivitiesAroundLoadingSelector = exports.getUserChallengeAttemptsDataSelector = exports.getUserChallengeActivitiesAroundDataSelector = exports.getUserChallengeActivitiesLoadingSelector = exports.getUserChallengeActivitiesDataSelector = exports.getUpdateUserChallengeSuccess = exports.getUserChallengeDataSelector = exports.getUserRegistrationLoadingSelector = exports.getUserRegistrationErrorSelector = exports.getUserRegistrationSuccessSelector = exports.getUserGroupChallengeContributionLoadingSelector = exports.getUserGroupChallengeContributionDataSelector = exports.userRegisteredChallengesErrorSelector = exports.userRegisteredChallengesDataSelector = exports.userRegisteredChallengesSelector = exports.userChallengesStateSelector = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("lodash/get"));

var userStateSelector = function userStateSelector(state) {
  return state.user;
};

var userChallengesStateSelector = (0, _reselect.createSelector)(userStateSelector, function (user) {
  return user.challenges;
});
exports.userChallengesStateSelector = userChallengesStateSelector;
var userRegisteredChallengesSelector = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenges) {
  return challenges.userRegisteredChallenges;
});
exports.userRegisteredChallengesSelector = userRegisteredChallengesSelector;
var userRegisteredChallengesDataSelector = (0, _reselect.createSelector)(userRegisteredChallengesSelector, function (userRegisteredChallenges) {
  return userRegisteredChallenges ? userRegisteredChallenges.data : null;
});
exports.userRegisteredChallengesDataSelector = userRegisteredChallengesDataSelector;
var userRegisteredChallengesMetaSelector = (0, _reselect.createSelector)(userRegisteredChallengesSelector, function (userRegisteredChallenges) {
  return userRegisteredChallenges ? userRegisteredChallenges.meta : null;
});
var userRegisteredChallengesHasNextSelector = (0, _reselect.createSelector)(userRegisteredChallengesMetaSelector, function (userRegisteredChallengesMeta) {
  return userRegisteredChallengesMeta ? userRegisteredChallengesMeta.hasNext : null;
});
var userRegisteredChallengesErrorSelector = (0, _reselect.createSelector)(userRegisteredChallengesSelector, function (userRegisteredChallenges) {
  return userRegisteredChallenges ? userRegisteredChallenges.error : null;
});
exports.userRegisteredChallengesErrorSelector = userRegisteredChallengesErrorSelector;
var getUserGroupChallengeContribution = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'userGroupChallengeContribution');
});
var getUserGroupChallengeContributionDataSelector = (0, _reselect.createSelector)(getUserGroupChallengeContribution, function (userGroupChallengeContribution) {
  return (0, _get["default"])(userGroupChallengeContribution, 'data');
});
exports.getUserGroupChallengeContributionDataSelector = getUserGroupChallengeContributionDataSelector;
var getUserGroupChallengeContributionLoadingSelector = (0, _reselect.createSelector)(getUserGroupChallengeContribution, function (userGroupChallengeContribution) {
  return (0, _get["default"])(userGroupChallengeContribution, 'isLoading');
});
exports.getUserGroupChallengeContributionLoadingSelector = getUserGroupChallengeContributionLoadingSelector;
var getUserRegistration = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'registration');
});
var getUserRegistrationSuccessSelector = (0, _reselect.createSelector)(getUserRegistration, function (userRegistration) {
  return (0, _get["default"])(userRegistration, 'success');
});
exports.getUserRegistrationSuccessSelector = getUserRegistrationSuccessSelector;
var getUserRegistrationErrorSelector = (0, _reselect.createSelector)(getUserRegistration, function (userRegistration) {
  return (0, _get["default"])(userRegistration, 'error');
});
exports.getUserRegistrationErrorSelector = getUserRegistrationErrorSelector;
var getUserRegistrationLoadingSelector = (0, _reselect.createSelector)(getUserRegistration, function (userRegistration) {
  return (0, _get["default"])(userRegistration, 'isLoading');
});
exports.getUserRegistrationLoadingSelector = getUserRegistrationLoadingSelector;
var getUserChallengeStateSelector = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'userChallenge');
});
var getUserChallengeDataSelector = (0, _reselect.createSelector)(getUserChallengeStateSelector, function (userChallenge) {
  return (0, _get["default"])(userChallenge, 'data');
});
exports.getUserChallengeDataSelector = getUserChallengeDataSelector;
var getUpdateUserChallengeSuccess = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'hasUpdatedUserChallenge');
});
exports.getUpdateUserChallengeSuccess = getUpdateUserChallengeSuccess;
var getUserChallengeActivities = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'userChallengeActivities');
});
var getUserChallengeActivitiesDataSelector = (0, _reselect.createSelector)(getUserChallengeActivities, function (userChallengeActivities) {
  return (0, _get["default"])(userChallengeActivities, 'data');
});
exports.getUserChallengeActivitiesDataSelector = getUserChallengeActivitiesDataSelector;
var getUserChallengeActivitiesLoadingSelector = (0, _reselect.createSelector)(getUserChallengeActivities, function (userChallengeActivities) {
  return (0, _get["default"])(userChallengeActivities, 'isLoading');
});
exports.getUserChallengeActivitiesLoadingSelector = getUserChallengeActivitiesLoadingSelector;
var getUserChallengeActivitiesAround = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'userChallengeActivitiesAround');
});
var getUserChallengeActivitiesAroundDataSelector = (0, _reselect.createSelector)(getUserChallengeActivitiesAround, function (userChallengeActivitiesAround) {
  return (0, _get["default"])(userChallengeActivitiesAround, 'data');
});
exports.getUserChallengeActivitiesAroundDataSelector = getUserChallengeActivitiesAroundDataSelector;
var getUserChallengeAttempts = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'userChallengeAttempts');
});
var getUserChallengeAttemptsDataSelector = (0, _reselect.createSelector)(getUserChallengeAttempts, function (userChallengeAttempts) {
  return (0, _get["default"])(userChallengeAttempts, 'data');
});
exports.getUserChallengeAttemptsDataSelector = getUserChallengeAttemptsDataSelector;
var getUserChallengeActivitiesAroundLoadingSelector = (0, _reselect.createSelector)(getUserChallengeActivitiesAround, function (userChallengeActivitiesAround) {
  return (0, _get["default"])(userChallengeActivitiesAround, 'isLoading');
});
exports.getUserChallengeActivitiesAroundLoadingSelector = getUserChallengeActivitiesAroundLoadingSelector;
var getUserGroupChallengeSelector = (0, _reselect.createSelector)(userChallengesStateSelector, function (challenge) {
  return (0, _get["default"])(challenge, 'userGroupChallenge');
});
exports.getUserGroupChallengeSelector = getUserGroupChallengeSelector;
var getUserGroupChallengeDataSelector = (0, _reselect.createSelector)(getUserGroupChallengeSelector, function (userGroup) {
  return (0, _get["default"])(userGroup, 'data');
});
exports.getUserGroupChallengeDataSelector = getUserGroupChallengeDataSelector;
var getIsUserGroupChallengeLoadingSelector = (0, _reselect.createSelector)(getUserGroupChallengeSelector, function (userGroup) {
  return (0, _get["default"])(userGroup, 'isLoading');
});
exports.getIsUserGroupChallengeLoadingSelector = getIsUserGroupChallengeLoadingSelector;
var getUserGroupChallengeRequestResult = (0, _reselect.createSelector)(getUserGroupChallengeSelector, function (userGroup) {
  return (0, _get["default"])(userGroup, 'requestResult');
});
exports.getUserGroupChallengeRequestResult = getUserGroupChallengeRequestResult;
var _default = {
  getUpdateUserChallengeSuccess: getUpdateUserChallengeSuccess,
  getUserChallengeActivitiesAroundDataSelector: getUserChallengeActivitiesAroundDataSelector,
  getUserChallengeActivitiesAroundLoadingSelector: getUserChallengeActivitiesAroundLoadingSelector,
  getUserChallengeActivitiesDataSelector: getUserChallengeActivitiesDataSelector,
  getUserChallengeActivitiesLoadingSelector: getUserChallengeActivitiesLoadingSelector,
  getUserChallengeAttemptsDataSelector: getUserChallengeAttemptsDataSelector,
  getUserChallengeDataSelector: getUserChallengeDataSelector,
  getUserGroupChallengeContributionDataSelector: getUserGroupChallengeContributionDataSelector,
  getUserGroupChallengeContributionLoadingSelector: getUserGroupChallengeContributionLoadingSelector,
  getUserRegistrationErrorSelector: getUserRegistrationErrorSelector,
  getUserRegistrationLoadingSelector: getUserRegistrationLoadingSelector,
  getUserRegistrationSuccessSelector: getUserRegistrationSuccessSelector,
  getUserGroupChallengeSelector: getUserGroupChallengeSelector,
  userRegisteredChallengesDataSelector: userRegisteredChallengesDataSelector,
  userRegisteredChallengesHasNextSelector: userRegisteredChallengesHasNextSelector,
  userRegisteredChallengesMetaSelector: userRegisteredChallengesMetaSelector,
  userRegisteredChallengesSelector: userRegisteredChallengesSelector,
  getUserGroupChallengeDataSelector: getUserGroupChallengeDataSelector,
  getIsUserGroupChallengeLoadingSelector: getIsUserGroupChallengeLoadingSelector,
  getUserGroupChallengeRequestResult: getUserGroupChallengeRequestResult
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map